import React, { useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Grid,
  Tooltip,
} from "@mui/material";

import GeneralCkeditor from "../../../components/editors/GeneralCkEditor";
import { show_proper_words } from "../../../utils/Constant";
import InfoIconWithCustomTooltip from "../../../components/InfoIconWithTooltip/InfoIconWithCustomTooltip";
import { enqueueSnackbar } from "notistack";

import { feedback_business_icon, feedback_person_icon, position_icon, } from "../../../assets";

const tagsList = [
  {
    name: "Candidate Name",
    value: "${candidate_name}",
    src: feedback_person_icon,
  },
  {
    name: "Position Name",
    value: "${position_name}",
    src: position_icon,
  },
  {
    name: "Company Name",
    value: "${company_name}",
    src: feedback_business_icon,
  },
];

const EditEmailTemplate = ({ template, setTemplate }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTemplate({ ...template, [name]: value });
  };

  return (
    <>
      {/* <div className="d-flex align-items-center">
          <h6 className="mb-0">Edit {show_proper_words(template.type)}</h6>
          <InfoIconWithCustomTooltip
            toolTipInfo={
              "The placeholders in email body (e.g., ${candidate_name}, ${position_name}, ${company_name}) will be filled with the appropriate information when the email is delivered."
            }
          />
        </div> */}
      <div>
        <Grid container spacing={2} >
          <Grid item xs={12} md={6} className="mt-2 mt-lg-4">
            <div className="custom-input-design">
              <label>Title*</label>
              <input
                fullWidth
                required
                placeholder="Enter title"
                variant="outlined"
                name="title"
                value={template.title}
                onChange={handleChange}
                error={!!template.errors_title}
                helperText={template.errors_title}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6} className="mt-2 mt-lg-4">
            <div className="custom-input-design">
              <label>CC Email</label>
              <input
                fullWidth
                placeholder="CC Email"
                variant="outlined"
                name="cc_email"
                value={template.cc_email}
                onChange={handleChange}
              />
            </div>
          </Grid>

          <Grid item xs={12} md={6} className="mt-2">
            <div className="custom-input-design">
              <label>Email Subject*</label>
              <input
                required
                fullWidth
                placeholder="Enter Subject"
                variant="outlined"
                name="email_subject"
                value={template.email_subject}
                onChange={handleChange}
                error={!!template.errors_email_subject}
                helperText={template.errors_email_subject}
              />
            </div>
          </Grid>

          {/* <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                variant="outlined"
                className="mt-3"
                required
              >
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  name="status"
                  value={template.status}
                  onChange={handleChange}
                >
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}

          <Grid item xs={12} className="mt-2 pe-0 w-100">
            <div className="custom-input-design">
              <label>Email Body * </label>
              <GeneralCkeditor
                inputs={template}
                setInputs={setTemplate}
                name="email_message"
                customHandleChange={handleChange}
              />
            </div>
          </Grid>
          <Grid item xs={12} className="mt-2 pe-0 w-100">

            <h6>
              Email Tags{" "}
              <InfoIconWithCustomTooltip toolTipInfo="You can copy tags and paste them in the email body." />
            </h6>
            <div className="d-flex tw-gap-2 align-items-center">
              {tagsList.map((item, index) => (
                <div className="custom-input-design" key={index}>
                  <Tooltip placement="top" title="Click to copy tag">
                    <div
                      className="chip-input pointer"
                      onClick={async () => {
                        await navigator.clipboard.writeText(item.value);
                        enqueueSnackbar("Tag copied to clipboard!", {
                          variant: "success",
                        });
                      }}
                    >
                      {item.src && (
                        <img
                          src={item.src}
                          alt={item.name}
                          className="me-2"
                        />
                      )}
                      {item.name}
                    </div>
                  </Tooltip>
                </div>
              ))}

            </div>
          </Grid>
        </Grid>
      </div>

    </>
  );
};

export default EditEmailTemplate;
